export enum Subpaths {
    AccessDenied = '/403',
    About = '/about',
    Account = '/account',
    CaliforniaPrivacy = '/california-privacy',
    CCPA = '/ccpa',
    Compensation = '/compensation',
    CompensationToken = '/compensation/[token]',
    Contact = '/contact',
    CreatePassword = '/create-password',
    CreatePasswordToken = '/create-password/[token]',
    Enroll = '/enroll',
    EnrollLogIdToken = '/enroll/[logId]/[token]',
    CompensationProvisions = '/compensation-provisions',
    Identity = '/identity',
    IdentityToken = '/identity/[token]',
    IdentityTokenStart = '/identity/[token]/start',
    WalletIntro = '/wallet-intro',
    Wallet = '/wallet',
    WalletPayment = '/wallet/payment',
    Login = '/login',
    Login2FA = '/login/2fa',
    Login2FAMethod = '/login/2fa/method',
    Login2FASubmit = '/login/2fa/submit',
    LoginRecaptcha = '/login/recaptcha',
    LoginMessage = '/login/message',
    LoginConfirmPassword = '/login/confirm-password',
    Terms = '/terms',
    Verification = '/verification',
    VerificationToken = '/verification/[token]',
    GetConfirmed = '/getconfirmed',
    Mreg = '/mreg',
    MregWithToken = '/mreg/[token]',
    Forbidden = '/403',
    AboutVersion = '/about/version',
    Out = '/out',
    SurveyTimeout = '/survey-timeout',
    SurveyTimeoutWithSurveyKeyAndUserId = '/survey-timeout/[surveyKey]/[userId]',
    Dashboard = '/dashboard',
    DashboardToken = '/dashboard/[token]',
    Support = '/support',
    Screening = '/screening',
    Logout = '/logout',
    Referrals = '/referrals',
    ProfileIntro = '/profile-intro',
    EmailConfirmation = '/email-confirmation',
    EmailConfirmationUserEmailId = '/email-confirmation/[userEmailId]',
    EmailConfirmationUserEmailIdToken = '/email-confirmation/[userEmailId]/[token]',
    Surveys = '/surveys',
    Profile = '/profile',
    ProfileControl = '/profile/control',
    AccountProfessionalDetails = '/account/professional-details',
    AccountInvoicing = '/account/invoicing',
    AccountPersonalDetails = '/account/personal-details',
    AccountContactPreferences = '/account/contact-preferences',
    AccountAuthenticatorApp = '/account/authenticator-app',
    AccountTaxDetails = '/account/tax-details',
    AccountContactDetails = '/account/contact-details',
    AccountPasswordChange = '/account/password-change',
    ForgottenPassword = '/forgotten-password',
    ForgottenPasswordNewPass = '/forgotten-password/new-pass',
    ForgottenPasswordNewPassToken = '/forgotten-password/new-pass/[token]',
    ForgottenPasswordResetSuccessful = '/forgotten-password/reset-successful',
    Yoti = '/yoti',
    Home = '/',
    NotFound = '/404',
    Unsubscribe = '/unsubscribe',
    Pages = '/pages',
    PagesToken = '/pages/[token]',
    SelectOpinion = '/select-opinion',
    SelectOpinionRegistration = '/select-opinion/registration',
    SelectOpinionConsultingOpportunities = '/select-opinion/consulting-opportunities',
    SelectOpinionCodeOfConduct = '/select-opinion/code-of-conduct',
    SelectOpinionPrivacyPolicy = '/select-opinion/privacy-policy',
    SelectOpinionMasterUserAgreement = '/select-opinion/master-user-agreement',
    SelectOpinionFaqPage = '/select-opinion/faq',
    TaxFaq = '/tax-faq',
    Faq = '/faq',
    Privacy = '/privacy',
    Cookies = '/cookies',
}
